import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-left" }
const _hoisted_4 = { class: "refine-example" }
const _hoisted_5 = {
  key: 1,
  class: "no-data"
}
const _hoisted_6 = { class: "related-rules" }
const _hoisted_7 = { class: "related-rules-content" }
const _hoisted_8 = {
  key: 0,
  class: "rules-list"
}
const _hoisted_9 = { class: "rules-container" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "rule-type" }
const _hoisted_12 = {
  key: 1,
  class: "no-rules"
}
const _hoisted_13 = { class: "modal-right" }
const _hoisted_14 = { class: "rules-content" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "rule-category"
}
const _hoisted_17 = { class: "rule-number" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "refine-rule-type" }
const _hoisted_20 = { class: "original-example" }
const _hoisted_21 = { class: "rule-example-container" }
const _hoisted_22 = { class: "checkbox-container" }
const _hoisted_23 = ["checked", "onChange"]
const _hoisted_24 = { class: "refine-rule-example" }
const _hoisted_25 = {
  key: 1,
  class: "checkbox-container"
}
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = { class: "refine-rule-example" }
const _hoisted_28 = {
  key: 1,
  class: "rule-category"
}
const _hoisted_29 = { class: "rule-number" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { class: "refine-rule-type" }
const _hoisted_32 = { class: "original-example" }
const _hoisted_33 = { class: "rule-example-container" }
const _hoisted_34 = { class: "checkbox-container" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "refine-rule-example" }
const _hoisted_37 = {
  key: 2,
  class: "rule-category"
}
const _hoisted_38 = { class: "rule-number" }
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = { class: "refine-rule-type" }
const _hoisted_41 = { class: "rule-example-container" }
const _hoisted_42 = { class: "checkbox-container" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { class: "refine-rule-example" }
const _hoisted_45 = {
  key: 1,
  class: "no-rules"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "close-icon" }, "×", -1)
      ])),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "example-section-header" }, [
            _createElementVNode("span", { class: "title-text" }, "Refine Example")
          ], -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["data-table-container", { 'scrollable-table': _ctx.tableNeedsScroll }])
          }, [
            (_ctx.selectedData && _ctx.selectedData.length > 0)
              ? (_openBlock(), _createElementBlock("table", {
                  key: 0,
                  class: _normalizeClass(["data-table", { 'table-flex-width': _ctx.tableNeedsScroll }])
                }, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUniqueColumns(), (item, index) => {
                        return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFormattedData(), (row, rowIndex) => {
                      return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, colIndex) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: colIndex,
                            class: _normalizeClass({ 'highlighted-cell': cell.isHighlighted })
                          }, _toDisplayString(cell.value), 3))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, "There are no relevant rules."))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "rules-section-header" }, [
            _createElementVNode("span", { class: "title-text-2" }, "Related Rules")
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.hasRules)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueRuleTypes, (ruleType, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `rule-${index}`,
                        class: "rule-item"
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.getRuleIcon(ruleType),
                          class: "related-rule-icon",
                          alt: ruleType
                        }, null, 8, _hoisted_10),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(ruleType), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, "There are no relevant rules."))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "right-section-header" }, [
          _createElementVNode("span", { class: "title-text" }, "Refine Rules")
        ], -1)),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.hasRules)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_ctx.updateRules.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "refine-title" }, [
                        _createElementVNode("img", {
                          src: "/refinemodel_icon/arrow.svg",
                          class: "arrow_icon"
                        }),
                        _createElementVNode("span", null, "Modify")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateRules, (rule, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `update-${index}`,
                          class: "rule-item"
                        }, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(index + 1) + ".", 1),
                          _createElementVNode("img", {
                            src: _ctx.getRuleIcon(rule.type),
                            class: "rule-icon",
                            alt: rule.type
                          }, null, 8, _hoisted_18),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.getDisplayRuleType(rule.type)), 1),
                          _createElementVNode("span", _hoisted_20, " (" + _toDisplayString(_ctx.getOriginalExample(rule)) + ") ", 1),
                          _createElementVNode("div", _hoisted_21, [
                            (_ctx.hasMultipleExamples(rule))
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.splitRefineExamples(
                        _ctx.getRefineExample(rule)
                      ), (example, exampleIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: `example-${exampleIndex}`,
                                    class: "example-item"
                                  }, [
                                    _createElementVNode("label", _hoisted_22, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: _ctx.isExampleSelected(rule, example),
                                        onChange: ($event: any) => (_ctx.toggleExampleSelection(rule, example)),
                                        class: "example-checkbox"
                                      }, null, 40, _hoisted_23),
                                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                                      _createElementVNode("span", _hoisted_24, _toDisplayString(example), 1)
                                    ])
                                  ]))
                                }), 128))
                              : (_openBlock(), _createElementBlock("label", _hoisted_25, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((rule.exampleSelected) = $event),
                                    class: "example-checkbox"
                                  }, null, 8, _hoisted_26), [
                                    [_vModelCheckbox, rule.exampleSelected]
                                  ]),
                                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.getRefineExample(rule)), 1)
                                ]))
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.addRules.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "refine-title" }, [
                        _createElementVNode("img", {
                          src: "/refinemodel_icon/arrow.svg",
                          class: "arrow_icon"
                        }),
                        _createElementVNode("span", null, "Add")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addRules, (rule, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `add-${index}`,
                          class: "rule-item"
                        }, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(index + 1) + ".", 1),
                          _createElementVNode("img", {
                            src: _ctx.getRuleIcon(rule.type),
                            class: "rule-icon",
                            alt: rule.type
                          }, null, 8, _hoisted_30),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.getDisplayRuleType(rule.type)), 1),
                          _createElementVNode("span", _hoisted_32, " (" + _toDisplayString(_ctx.getOriginalExample(rule)) + ") ", 1),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("label", _hoisted_34, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((rule.exampleSelected) = $event),
                                class: "example-checkbox"
                              }, null, 8, _hoisted_35), [
                                [_vModelCheckbox, rule.exampleSelected]
                              ]),
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.getRefineExample(rule)), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.deleteRules.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "refine-title" }, [
                        _createElementVNode("img", {
                          src: "/refinemodel_icon/arrow.svg",
                          class: "arrow_icon"
                        }),
                        _createElementVNode("span", null, "Delete")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deleteRules, (rule, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `delete-${index}`,
                          class: "rule-item"
                        }, [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(index + 1) + ".", 1),
                          _createElementVNode("img", {
                            src: _ctx.getRuleIcon(rule.type),
                            class: "rule-icon",
                            alt: rule.type
                          }, null, 8, _hoisted_39),
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.getDisplayRuleType(rule.type)), 1),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("label", _hoisted_42, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((rule.exampleSelected) = $event),
                                class: "example-checkbox"
                              }, null, 8, _hoisted_43), [
                                [_vModelCheckbox, rule.exampleSelected]
                              ]),
                              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.getDeleteSummary(rule)), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_45, "There are no relevant rules."))
        ]),
        _createElementVNode("button", {
          class: "submit-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitModal && _ctx.submitModal(...args)))
        }, _cache[12] || (_cache[12] = [
          _createElementVNode("img", {
            src: "/refinemodel_icon/mark.svg",
            class: "mark_icon"
          }, null, -1),
          _createTextVNode(" Submit ")
        ]))
      ])
    ])
  ]))
}